import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    window.history.scrollRestoration = "manual";
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    // Reload the home page to reset verification data
    window.location.assign("/");
  };

  return (
    <header className="w-full bg-white text-black relative z-50">
      <div
        className="
          max-w-[1280px] mx-auto
          relative
          px-3 sm:px-4 md:px-14
          py-4 md:pt-6 md:pb-4
        "
      >
        {/* Top bar for mobile / Side elements for desktop */}
        <div className="flex flex-row justify-between items-center w-full">
          {/* LEFT */}
          <div
            onClick={() => navigate("/whyvastavik")}
            className="
              font-maxwell
              text-[14px] sm:text-[16px] md:text-[22px]
              leading-none
              tracking-wide
              text-[#DC2323]
              cursor-pointer
              underline
              underline-offset-[4px] md:underline-offset-[6px]
              decoration-[#DC2323]
              decoration-solid
              decoration-[2px]
              hover:opacity-70
              transition
              md:mt-2
              z-10
            "
          >
            Why VASTAVIK ?
          </div>

          {/* RIGHT — Create Account / Login */}
          <div className="flex flex-row items-center gap-2 sm:gap-3 z-10 md:mr-0 lg:mr-[20px] xl:mr-[45px]">
            <a
              href="https://creator.vastavik.org/register"
              target="_blank"
              rel="noopener noreferrer"
              className="
                flex items-center justify-center shrink-0
                h-[36px] px-3
                sm:h-[42px] sm:px-4

                /* Exact match to Verify button on Desktop */
                md:w-[222px] md:h-[42px] md:px-[13px] md:py-[11px]
                rounded-[8px] md:rounded-[5px]

                bg-[#131313]
                text-white

                font-productsans-medium
                text-[11px] sm:text-[13px] md:text-[15px]
                tracking-[-0.01em]
                whitespace-nowrap

                hover:opacity-90
                hover:no-underline
                transition
              "
            >
              Create Account for free
            </a>

            <a
              href="https://creator.vastavik.org/login"
              target="_blank"
              rel="noopener noreferrer"
              className="
                flex items-center justify-center shrink-0
                h-[36px] px-3
                sm:h-[42px] sm:px-4

                /* Matched height and rounding to the Create Account button */
                md:h-[42px] md:px-5
                rounded-[8px] md:rounded-[5px]

                bg-white
                text-black
                border border-black

                font-productsans-medium
                text-[11px] sm:text-[13px] md:text-[15px]
                tracking-[-0.01em]
                whitespace-nowrap

                hover:bg-black
                hover:text-white
                hover:no-underline
                transition
              "
            >
              Login
            </a>
          </div>
        </div>

        {/* CENTER */}
        <div
          className="
            flex flex-col items-center text-center
            w-full
            mt-16 sm:mt-20 md:mt-12
            z-0
          "
        >
          <h1
            onClick={handleHomeClick}
            className="
              font-maxwell
              text-[44px] sm:text-[48px] md:text-[60px]
              leading-[0.92]
              tracking-[-0.055em]
              uppercase
              text-black
              cursor-pointer
              mb-1 md:mb-3
            "
          >
            VASTAVIK
          </h1>

          <p className="block font-caviar font-bold text-[13px] sm:text-[14px] md:text-[18px] leading-[1.2] md:leading-none text-black/75 whitespace-normal md:whitespace-nowrap">
            If it's not on{" "}
            <span className="text-[#CD0101]">VASTAVIK</span>, it could be{" "}
            <span className="text-[#CD0101]">fake.</span>
          </p>
        </div>
      </div>
    </header>
  );
}